import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '@cbm/shared';
import { PlantManagerDashboard } from '../dashboards/PlantManagerDashboard';
import { PlantOperatorDashboard } from '../dashboards/PlantOperatorDashboard';
import { OEMServiceDashboard } from '../dashboards/OEMServiceDashboard';
import { OEMEngineeringDashboard } from '../dashboards/OEMEngineeringDashboard';
import { QualityDashboard as QualityDashboardComponent } from '../dashboards/QualityDashboard';

const ADMIN_EMAIL = 'anbunathan.r@gmail.com';

function hasAccess(user: any, requiredRole: UserRole): boolean {
  if (user.email === ADMIN_EMAIL) return true;
  if (user.role === requiredRole) return true;
  
  const roleMap: Record<string, UserRole> = {
    'oem_service': 'OEM_SERVICE',
    'oem_engineering': 'OEM_ENGINEERING',
    'plant_operator': 'PLANT',
    'plant_manager': 'PLANT',
    'quality': 'QUALITY',
    'simulation': 'PLANT'
  };
  
  if (user.roles) {
    for (const r of user.roles) {
      if (roleMap[r] === requiredRole) return true;
    }
  }
  return false;
}
const ROLE_DASHBOARDS: Record<UserRole, React.ComponentType> = {
  PLANT: PlantManagerDashboard,
  OEM_SERVICE: OEMServiceDashboard,
  OEM_ENGINEERING: OEMEngineeringDashboard,
  QUALITY: QualityDashboardComponent,
};

// Role-based dashboard paths
export const DASHBOARD_PATHS: Record<UserRole, string> = {
  PLANT: '/dashboard/plant',
  OEM_SERVICE: '/dashboard/oem-service',
  OEM_ENGINEERING: '/dashboard/oem-engineering',
  QUALITY: '/dashboard/quality',
};

export function getDashboardPath(role: UserRole): string {
  return DASHBOARD_PATHS[role];
}

function isAdmin(email?: string): boolean {
  return email === ADMIN_EMAIL;
}

export function DashboardRouter() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const DashboardComponent = ROLE_DASHBOARDS[user.role];
  
  if (!DashboardComponent) {
    return (
      <div className="p-6">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Access Error</h1>
        <p className="text-gray-600">No dashboard available for your role: {user.role}</p>
      </div>
    );
  }

  return <DashboardComponent />;
}

export function PlantDashboard() {
  const { user } = useAuth();
  
  if (!user || !hasAccess(user, 'PLANT')) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return <PlantManagerDashboard />;
}

export function PlantOperatorDashboardRoute() {
  const { user } = useAuth();
  
  if (!user || !hasAccess(user, 'PLANT')) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return <PlantOperatorDashboard />;
}

export function OEMServiceDashboardRoute() {
  const { user } = useAuth();
  
  if (!user || !hasAccess(user, 'OEM_SERVICE')) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return <OEMServiceDashboard />;
}

export function OEMEngineeringDashboardRoute() {
  const { user } = useAuth();
  
  if (!user || !hasAccess(user, 'OEM_ENGINEERING')) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return <OEMEngineeringDashboard />;
}

export function QualityDashboard() {
  const { user } = useAuth();
  
  if (!user || !hasAccess(user, 'QUALITY')) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return <QualityDashboardComponent />;
}